import {PropertyItem} from 'common/widgets/query-block/properties-menu/types';
import {PropertyType, ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {DATASET_PROPERTY_NAME} from 'common/report/constants';

export const TOP_PEOPLE: PropertyItem = {
  type: null,
  propertyDefaultType: null,
  hasCaret: false,
  hasPill: false,
  icon: `profile`,
  isDisabled: false,
  label: `All User Profiles`,
  value: `$all_people`,
  resourceType: ResourceType.User,
};

export const TOP_PATHS: PropertyItem = {
  type: PropertyType.NonProperty,
  propertyDefaultType: PropertyType.NonProperty,
  hasCaret: false,
  hasPill: false,
  icon: `top-paths`,
  isDisabled: false,
  label: `Top paths`,
  value: `$paths`,
  resourceType: ResourceType.Other,
};

export const ALL_USERS_COHORT: PropertyItem = {
  type: null,
  propertyDefaultType: null,
  hasCaret: false,
  hasPill: false,
  isDisabled: false,
  label: `All Users`,
  value: `$all_users`,
  resourceType: ResourceType.Cohort,
};

export const DATE_PROPERTY: PropertyItem = {
  label: `Date`,
  icon: `star-top-events`,
  value: `$date`,
  propertyDefaultType: PropertyType.Datetime,
  type: PropertyType.Datetime,
  resourceType: ResourceType.Event,
  isControlItem: true,
};

export const FIRST_EVENT_TIME_PROPERTY: PropertyItem = {
  label: `First Seen`,
  icon: `calendar`,
  value: `$mp_first_event_time`,
  propertyDefaultType: PropertyType.Datetime,
  type: PropertyType.Datetime,
  resourceType: ResourceType.User,
  isControlItem: true,
};

export const FIRST_TIME_PROPERTY: PropertyItem = {
  label: `1st time ever`,
  icon: `type-boolean`,
  value: `$nth_time_event`,
  propertyDefaultType: PropertyType.NonProperty,
  type: PropertyType.NonProperty,
  resourceType: ResourceType.Event,
  isControlItem: true,
  tooltipData: {
    header: `1st time filter`,
    description: `Only count a user's 1st time ever doing this event`,
    helpLink: {
      label: `More on 1st time filters`,
      href: `https://help.mixpanel.com/hc/en-us/articles/360001355506#1st-time-filters`,
    },
  },
};

export const DATASET_PROPERTY: PropertyItem = {
  label: `Project Name`,
  icon: `star-top-events`,
  value: DATASET_PROPERTY_NAME,
  propertyDefaultType: PropertyType.String,
  type: PropertyType.String,
  resourceType: ResourceType.Event,
};

export const SPECIAL_PROPERTIES: Map<string, PropertyItem> = new Map([
  [TOP_PEOPLE.value, TOP_PEOPLE],
  [TOP_PATHS.value, TOP_PATHS],
  [ALL_USERS_COHORT.value, ALL_USERS_COHORT],
  [DATE_PROPERTY.value, DATE_PROPERTY],
  [FIRST_EVENT_TIME_PROPERTY.value, FIRST_EVENT_TIME_PROPERTY],
  [FIRST_TIME_PROPERTY.value, FIRST_TIME_PROPERTY],
  [DATASET_PROPERTY.value, DATASET_PROPERTY],
]);

export const OTHER_OPTIONS: Map<string, PropertyItem> = new Map([[TOP_PATHS.value, TOP_PATHS]]);

export const SPECIAL_CONTROLS = {
  CREATE_INLINE_COHORT: {
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    icon: `compose`,
    label: `Create Cohort...`,
    resourceType: ResourceType.Cohort,
    value: `create_inline_cohort`,
  },
  CREATE_CUSTOM_EVENT_FORMULA: {
    icon: `compose`,
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    label: `Create a Custom Property...`,
    resourceType: ResourceType.Event,
    value: `create_custom_event_formula`,
    tooltipData: {
      header: `Create a Custom Property`,
      description: `• Merge and regroup property values\n• Resize numeric ranges\n• Extract patterns`,
      helpLink: {
        label: `More on custom properties`,
        href: `https://help.mixpanel.com/hc/en-us/articles/360030848432-Custom-Properties`,
      },
    },
  },
  CREATE_CUSTOM_PEOPLE_FORMULA: {
    icon: `compose`,
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    label: `Create a Custom Property...`,
    resourceType: ResourceType.User,
    value: `create_custom_people_formula`,
    tooltipData: {
      header: `Create a Custom Property`,
      description: `• Merge and regroup property values\n• Resize numeric ranges\n• Extract patterns`,
      helpLink: {
        label: `More on custom properties`,
        href: `https://help.mixpanel.com/hc/en-us/articles/360030848432-Custom-Properties`,
      },
    },
  },
  CREATE_CUSTOM_BEHAVIORAL_PROPERTY: {
    icon: `compose`,
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    label: `Create a Behavior...`,
    resourceType: ResourceType.User,
    value: `create_custom_behavioral_property`,
    tooltipData: {
      header: `Create a Behavior`,
      description: `Define properties based on user behavior patterns over time. Common use-cases include: number of times users did an action, summarize user's actions based on a property.`,
    },
  },
};
